// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__SwE4A","list":"BalanceDue_list__dyaqq","listRow":"BalanceDue_listRow__3g_sG","total":"BalanceDue_total__2Uoma"};